export default {
    path: ":alias/brands/arts",
    component: resolve => require(["@/views/arts"], resolve),
    children: [
      {
        path: "list",
        component: resolve => require(["@/views/arts/list"], resolve)
      }
    ]
  };
  